import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M6.5 16.75C5.811 16.75 5.25 17.311 5.25 18C5.25 18.689 5.811 19.25 6.5 19.25C7.189 19.25 7.75 18.689 7.75 18C7.75 17.311 7.189 16.75 6.5 16.75ZM6.25 18C6.25 17.862 6.362 17.75 6.5 17.75C6.638 17.75 6.75 17.862 6.75 18C6.75 18.275 6.25 18.275 6.25 18Z"
      fill="currentColor"
    />
    <path
      d="M20.971 15.357C20.968 15.345 20.968 15.334 20.964 15.323C20.93 15.234 20.87 15.163 20.795 15.107C20.787 15.101 20.785 15.09 20.777 15.084L16.403 12.168C16.238 12.058 16.047 12 15.849 12H8.151C7.953 12 7.761 12.058 7.596 12.168L3.222 15.084C3.213 15.09 3.212 15.101 3.204 15.107C3.129 15.163 3.069 15.234 3.035 15.323C3.031 15.334 3.032 15.346 3.028 15.357C3.015 15.403 3 15.449 3 15.5V20C3 20.552 3.449 21 4 21H20C20.552 21 21 20.552 21 20V15.5C21 15.449 20.985 15.403 20.971 15.357ZM8.151 13H15.848L18.848 15H5.151L8.151 13ZM20 20H4V16H20V20Z"
      fill="currentColor"
    />
    <path
      d="M9.35401 6.85398L11.5 4.70698V10.5C11.5 10.776 11.724 11 12 11C12.276 11 12.5 10.776 12.5 10.5V4.70698L14.646 6.85298C14.744 6.95098 14.872 6.99998 15 6.99998C15.128 6.99998 15.256 6.95098 15.354 6.85398C15.549 6.65898 15.549 6.34198 15.354 6.14698L12.355 3.14798C12.309 3.10198 12.253 3.06498 12.192 3.03898C12.07 2.98798 11.932 2.98798 11.81 3.03898C11.748 3.06398 11.692 3.10098 11.646 3.14698L8.64601 6.14598C8.45101 6.34098 8.45101 6.65798 8.64601 6.85298C8.84101 7.04798 9.15801 7.04898 9.35401 6.85398V6.85398Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Upload');

export default Icon;
